import { Component } from '@angular/core';

@Component({
  selector: 'mtm-rect-icon',
  templateUrl: './rect-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class RectIconComponent {}
